import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useIsMobile } from '@/shared/hooks/export';
import { useNotificationInbox } from '@/core/notifications/hooks/use-notification-inbox';
import { formatUnreadCount } from '@/core/notifications/model';
import { NotificationServiceContextProvider } from '@/core/notifications/contexts/notification-service-context';
import NotificationFlyout from './notification-flyout';
import { PopperMenu } from '@/shared/components/export';
import '@/core/notifications/components/inbox/notification-flyout.scss';
import '@/shared/theme/navbar-buttons.scss';

const badgeStyle = {
  top: -5,
  right: -5,
  fontSize: '0.6rem',
  minWidth: 16,
};

function NotificationBellInner() {
  const inbox = useNotificationInbox();
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile(576);

  const unreadCount = inbox.totalUnreadCount;

  const badge = unreadCount > 0 && (
    <span className="badge bg-danger position-absolute" style={badgeStyle}>
      {formatUnreadCount(unreadCount)}
    </span>
  );

  if (isMobile) {
    return (
      <span className="nav-item">
        <button
          aria-label="Notifications"
          className={`btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square ms-3 position-relative`}
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon icon={faBell} />
          {badge}
        </button>

        {open && <NotificationFlyout inbox={inbox} onClose={() => setOpen(false)} />}
      </span>
    );
  }

  return (
    <span className="nav-item">
      <PopperMenu
        toggle={
          <>
            <FontAwesomeIcon icon={faBell} />
            {badge}
          </>
        }
        toggleClassName={`btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square ms-3 position-relative`}
        toggleTitle="Notifications"
        fullWidth
        elevated
        menuClassName="notification-flyout bg-primary-700"
        menuStyle={{ padding: 0, borderRadius: 0, border: '1px solid var(--bs-primary-200)' }}
      >
        {close => <NotificationFlyout inbox={inbox} onClose={close} />}
      </PopperMenu>
    </span>
  );
}

export default function NotificationBell() {
  return (
    <NotificationServiceContextProvider>
      <NotificationBellInner />
    </NotificationServiceContextProvider>
  );
}
